import ricatti from "../../assets/ricatti.jpeg";
import cena from "../../assets/cena.jpeg";
import avila from "../../assets/avila.jpeg";
import cumino from "../../assets/cumino.jpeg";
import melgarejo from "../../assets/melgarejo.jpeg";
import pittaro from "../../assets/pittaro.jpeg";
import pausada from "../../assets/pausada.jpeg";
import barrionuevo from "../../assets/barrionuevo.jpeg";
import lesta from "../../assets/lesta.jpeg";
import garay from "../../assets/garay.jpeg";
import nayar from "../../assets/nashar.jpeg";
import bogarin from "../../assets/bogarin.jpeg";
import torres from "../../assets/torres.jpeg";
import garaydef from "../../assets/garaydef.jpeg";
import liziardi from "../../assets/liziardi.jpeg";
import palermo from "../../assets/palermo.jpeg";
import corro from "../../assets/corro.jpeg";
import asquenaggi from "../../assets/asquenaggi.jpeg";
export const sections = [
  {
    items: [
      {
        id: "pittaro-miguel-angel",
        name: "Pittaro Miguel Ángel",
        role: "Intendente",
        phone: "03525 - 491212",
        email: "intendente@lagranja.gob.ar",
        address: "San Martín 598, Jesús María",
        image: pittaro,
        linkedIn: "https://www.linkedin.com/in/miguelangelpittaro",
        twitter: "https://twitter.com/miguelangelpittaro",
        showInMenu: true,
        subordinates: [
          {
            id: "cumino-lisandro",
            name: "Dr. Cumino Lisandro",
            role: "Secretario de Gobierno",
            phone: "+54 9 3525 64-2892",
            email: "sec.gobierno@lagranja.gob.ar",
            showInMenu: true,
            image: cumino,
            subordinates: [
              {
                id: "ricatti-andres",
                name: "Ricatti Andres",
                role: "Secretario de Hacienda y Finanzas",
                image: ricatti,
                phone: "+54 9 3525 64-2892",
                email: "sec.finanzas@lagranja.gob.ar",
                showInMenu: true,
              },
              {
                id: "melgarejo-claudia",
                name: "Melgarejo Claudia",
                role: "Dirección de turismo y cultura",
                phone: "+54 9 3525 64-2892",
                email: "sec.turismo@lagranja.gob.ar",
                image: melgarejo,
                showInMenu: true,
                subordinates: [
                  {
                    id: "lic-garay-morena",
                    name: "Lic. Garay Morena",
                    role: "Directora de cultura",
                    phone: "+54 9 3525 64-2892",
                    image: garay,
                    email: "sec.turismo@lagranja.gob.ar",
                  },
                  {
                    id: "nayar-paula",
                    name: "Nayar Paula",
                    image: nayar,
                    role: "Directora de deporte",
                    phone: "+54 9 3525 64-2892",
                    email: "sec.turismo@lagranja.gob.ar",
                  },
                ],
              },
              {
                id: "pausada-marcelo",
                name: "Pausada Marcelo",
                image: pausada,
                role: "Secretario de Desarrollo Humano y Salud",
                phone: "+54 9 3525 62-0101",
                email: "sec.desarrollohumano@lagranja.gob.ar",
                showInMenu: true,
              },
              {
                id: "cena-fabricio",
                name: "Cena Fabricio",
                role: "Director de Obras Públicas",
                phone: "+54 9 3525 64-2892",
                email: "obraspublicas@lagranja.gob.ar",
                showInMenu: true,
                image: cena,
                subordinates: [
                  {
                    id: "palermo-jorge",
                    name: "Palermo Jorge",
                    image: palermo,
                    role: "Coordinador de Servicios Públicos",
                    phone: "+54 9 3525 64-2892",
                    email: "serviciospublicos@lagranja.gob.ar",
                  },
                ],
              },
              {
                id: "barrionuevo-daniela",
                name: "Barrionuevo Daniela",
                image: barrionuevo,
                role: "Directora del RRHH",
                phone: "+54 9 3525 64-2892",
                email: "rrhh@lagranja.gob.ar",
                showInMenu: true,
              },
              {
                id: "telmo-albrech",
                name: "Dra. Romagnioli Claudia ",
                image: "",
                role: "Directora centro de Salud",
                phone: "+54 9 3525 64-2892",
                email: "caps@lagranja.gob.ar",
                showInMenu: true,
              },
              {
                id: "avila-stella",
                name: "Arq. Ávila Stella",
                image: avila,
                role: "Área Obras Privadas",
                phone: "+54 9 3525 64-2892",
                email: "obrasprivadas@lagranja.gob.ar",
              },
              {
                id: "del-corro-maria",
                name: "Ing. Del Corro María del Carmen",
                image: corro,
                role: "Catastro",
                phone: "+54 9 3525 64-2892",
                email: "catastro@lagranja.gob.ar",
              },
              {
                id: "bogarin-romina",
                name: "Bogarín Romina",
                image: bogarin,
                role: "Área de Gestión de Cobranza",
                phone: "+54 9 3525 64-2892",
                email: "gestioncobranza@lagranja.gob.ar",
              },
              {
                id: "garay-mario",
                name: "Garay Mario",
                image: garaydef,
                role: "Def. Civil / Seguridad Ciudadana",
                phone: "03525 - 491212",
                email: "seguridad@lagranja.gob.ar",
              },
              {
                id: "asquenaggi-alberto",
                name: "Ing. Asquenaggi Alberto",
                role: "Director de Ambiente",
                image: asquenaggi,
                phone: "03525 - 404992",
                email: "ambiente@lagranja.gob.ar",
                subordinates: [
                  {
                    id: "lizarde-fabiana",
                    name: "Dvm. Liziardi Fabiana",
                    image: liziardi,
                    role: "Área de Zoonosis",
                    phone: "03525 - 491212",
                    email: "zoonosis@lagranja.gob.ar",
                  },
                ],
              },
              {
                id: "alexis-lesta",
                name: "Lesta Alexis",
                role: "Coordinador de Transporte",
                phone: "03525 - 434290",
                email: "munibus@lagranja.gob.ar",
                image: lesta,
              },
            ],
          },
        ],
      },
    ],
  },
];
